<template>
  <div>
    <v-row
      justify="space-around"
      align="center"
    >
      <v-col sm="6" md="6" style="flex: 0 1 auto;">
        <h3>Hora início:</h3>
        <v-time-picker
          v-model="localValue.horaInicio"
          :max="localValue.horaFim"
          format="24hr"
          :allowed-minutes="allowedStep"
          full-width
          elevation="1"
          header-color="success"
          scrollable
        ></v-time-picker>
      </v-col>
      <v-col sm="6" md="6" style="flex: 0 1 auto;">
        <h3>Hora fim:</h3>
        <v-time-picker
          v-model="localValue.horaFim"
          :min="localValue.horaInicio"
          format="24hr"
          :allowed-minutes="allowedStep"
          full-width
          elevation="1"
          header-color="warning"
          scrollable
          @blur="onBlur"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DateUtils from './utils/date-formatter-utils';

export default {
  props: ['value', 'label', 'inputClass'],
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    onSelectDate(data) {
      this.localValue = data;
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    allowedStep: (m) => m % 5 === 0,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  formattedDateInicio() {
    return DateUtils.formatTimeHourMinute(this.localValue.horaInicio);
  },
  formattedDateFim() {
    return DateUtils.formatTimeHourMinute(this.localValue.horaFim);
  },
};
</script>
